import { Injectable } from '@angular/core';
import { RoleRights } from '../../shared/enums';

@Injectable()
export class MenuService {

    menuItems: Array<any>;

    constructor() {
        this.menuItems = [];
    }

    addMenu(items: Array<{
        text: string,
        heading?: boolean,
        link?: string,
        icon?: string,
        alert?: string,
        roles?: Array<RoleRights>,
        submenu?: Array<any>
    }>) {
        items.forEach((item) => {
            this.menuItems.push(item);
        });
    }

    getMenu() {
        return this.menuItems;
    }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/core/menu/menu.service.ts